import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, PhoneCall } from "lucide-react";

const links = [
  { href: "/#palvelut", label: "Palvelut" },
  { href: "/#miksi", label: "Miksi me" },
  { href: "/#referenssit", label: "Referenssit" },
  { href: "/#ukk", label: "UKK" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  const goHash = (hash) => {
    if (pathname !== "/") window.location.href = hash;
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "backdrop-blur-xl bg-[#0B0D10]/80 border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="md-container flex items-center justify-between h-20 md:h-24">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <span className="inline-flex items-center justify-center rounded-xl bg-white px-3 py-1.5 transition-transform group-hover:scale-105">
            <img
              src="/myyntidrive-logo.png?v=7"
              srcSet="/myyntidrive-logo.png?v=7 1x, /myyntidrive-logo@2x.png?v=7 2x"
              alt="MyyntiDrive"
              className="h-7 md:h-8 w-auto block"
              width="217"
              height="128"
            />
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => goHash(l.href)}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm text-white/70 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a href="/#yhteys" className="md-btn-primary text-sm" data-testid="nav-cta-primary">
            <PhoneCall size={16} /> Varaa maksuton kartoitus
          </a>
        </div>

        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Avaa valikko"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/5 bg-[#0B0D10]/95 backdrop-blur-xl" data-testid="nav-mobile-menu">
          <div className="md-container py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-white/80 py-2 text-base"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
